import { render, staticRenderFns } from "./TimeConfig.vue?vue&type=template&id=68159377&scoped=true"
import script from "./TimeConfig.vue?vue&type=script&lang=js"
export * from "./TimeConfig.vue?vue&type=script&lang=js"
import style0 from "./TimeConfig.vue?vue&type=style&index=0&id=68159377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68159377",
  null
  
)

export default component.exports